import clsx from 'clsx';
import Button from "../../../Button";

import ChevronRight from "../../../../icons/ChevronRight";
import Edit from "../../../../icons/Edit";
import React from 'react';
import TitleWithSelectedIcon from "../TitleWithSelectedIcon";
import { createStyles } from "./styles";













var CardHeader = function CardHeader(props) {
  var classes = createStyles();
  var
    name =






    props.name,view = props.view,isConfigurable = props.isConfigurable,portfolioId = props.portfolioId,onViewPlanDetails = props.onViewPlanDetails,isCartItemSelected = props.isCartItemSelected,className = props.className;

  var isPortfolioView = view === 'PORTFOLIO';

  var ViewPlanDetailsButton = function ViewPlanDetailsButton(productId) {return /*#__PURE__*/(
      React.createElement(Button, {
        type: "text",
        color: "primary",
        rightIconProp: /*#__PURE__*/React.createElement(ChevronRight, null),
        className: classes.planDetailsButton,
        onClick: function onClick() {
          onViewPlanDetails(productId);
        } }, "View Plan Details"));};





  var ConfigureButton = function ConfigureButton(id) {return /*#__PURE__*/(
      React.createElement(Button, {
        type: "text",
        color: "primary",
        rightIconProp: /*#__PURE__*/React.createElement(Edit, null),
        className: classes.configureButton,
        onClick: function onClick() {
          if (props.onConfigurePortfolio) props.onConfigurePortfolio(id);
        } }, "Configure a plan"));};





  return /*#__PURE__*/(
    React.createElement("header", {
      // All classes here are style functions
      className: clsx(
      classes.header,
      !isConfigurable && isPortfolioView && classes.shortHeader,
      className) }, /*#__PURE__*/


    React.createElement(TitleWithSelectedIcon, {
      title: name,
      showIcon: isPortfolioView,
      isCartItemSelected: isCartItemSelected }),

    !isConfigurable ? /*#__PURE__*/
    // Show view plan details button only for portfolio view.
    React.createElement(React.Fragment, null, isPortfolioView && ViewPlanDetailsButton(portfolioId)) : /*#__PURE__*/

    React.createElement(React.Fragment, null,
    isPortfolioView && /*#__PURE__*/
    React.createElement("div", { className: classes.titleButtons },
    ViewPlanDetailsButton(portfolioId),
    ConfigureButton(portfolioId)))));






};

export default CardHeader;
//# sourceMappingURL=index.js.map